var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.833a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    stroke: "#4F5260",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.83 8.333c0 5-5.833 9.167-5.833 9.167s-5.833-4.167-5.833-9.167a5.833 5.833 0 0111.667 0z",
    stroke: "#4F5260"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMCAxMC44MzM0QzExLjM4MDcgMTAuODMzNCAxMi41IDkuNzE0MTIgMTIuNSA4LjMzMzM3QzEyLjUgNi45NTI2MiAxMS4zODA3IDUuODMzMzcgMTAgNS44MzMzN0M4LjYxOTI1IDUuODMzMzcgNy41IDYuOTUyNjIgNy41IDguMzMzMzdDNy41IDkuNzE0MTIgOC42MTkyNSAxMC44MzM0IDEwIDEwLjgzMzRaIiBzdHJva2U9IiM0RjUyNjAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPHBhdGggZD0iTTE1LjgzMDcgOC4zMzMzM0MxNS44MzA3IDEzLjMzMzMgOS45OTc0IDE3LjUgOS45OTc0IDE3LjVDOS45OTc0IDE3LjUgNC4xNjQwNiAxMy4zMzMzIDQuMTY0MDYgOC4zMzMzM0M0LjE2NDA2IDUuMTExNjcgNi43NzU3MyAyLjUgOS45OTc0IDIuNUMxMy4yMTkxIDIuNSAxNS44MzA3IDUuMTExNjcgMTUuODMwNyA4LjMzMzMzWiIgc3Ryb2tlPSIjNEY1MjYwIi8+Cjwvc3ZnPgo=";
export { SvgLocationIcon as ReactComponent };